import { ValidationError } from '../services/fourwaves/models/ValidationError';

export function tryGetClientSecretCode(response: ValidationError): string | null {
  if (response.errors[''] && response.errors[''].some(x => x.code === 'PAYMENT_REQUIRES_ACTION')) {
    const clientSecretError = response.errors[''].pop();
    return clientSecretError ? clientSecretError.code : null;
  }

  return null;
}
